<mat-dialog-content>
  <div test-id="CONFIRM_MESSAGE">{{(confirmationPrompt | cbsLabel) || confirmationPrompt}}</div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button class="c-button" test-id="YES_BUTTON" (click)="clickYes()">{{'yes' | cbsLabel}}</button>
  <button class="c-text-button" test-id="NO_BUTTON" (click)="clickNo()">{{'no' | cbsLabel}}</button>
</mat-dialog-actions>
